export default "__VITE_PUBLIC_ASSET__ddbab30f__"